import { db } from "@/fstore";
import firebase from "firebase/app";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    addTrackToUserFavorites({ rootState }, filename) {
      var update_object = {
        music_favorites: firebase.firestore.FieldValue.arrayUnion(filename)
      };
      db.collection("users")
        .doc(rootState.user.uid)
        .update(update_object)
        .then(function() {
          console.log("addTrackToUserFavorites", "success");
        });
    },
    removeTrackToUserFavorites({ rootState }, filename) {
      var update_object = {
        music_favorites: firebase.firestore.FieldValue.arrayRemove(filename)
      };
      db.collection("users")
        .doc(rootState.user.uid)
        .update(update_object)
        .then(function() {
          console.log("removeTrackToUserFavorites", "success");
        });
    }
  }
};
